export default function AboutUs() {
  return (
    <main>
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl text-clip  mx-auto space-y-12">
          {/* About the Trust Section */}
          <section className="bg-white p-2 sm:p-6 ">
            <h2 className="text-2xl sm:text-3xl font-semibold text-center">
              About the Trust
            </h2>
            <p className="mt-4 sm:text-lg text-justify">
              SNR Sons Charitable Trust was found in the year 1970 by the
              illustrious sons of Sri. S. N. Rangasamy Naidu namely, Late Sri
              Chinnasamy Naidu, Late Sri. P. R. Ramaswami Naidu, Sr. R.
              Doraiswami Naidu and Sevaratna Dr.R.Venkatesalu Naidu. Being an
              ardent devotee of Sri Ramakrishna Paramahamsa, all the
              institutions started by the Trust bear the name of the HolySage
              "Sri Ramakrishna".
            </p>
            <p className="mt-4 sm:text-lg text-justify">
              Following the Principles of Sri Ramakrishna Paramahamsa's
              Philosophy of God through man', the Trust successfully runs 15
              organisations significantly catering to social causes of society
              focusing on Health Care, Education and Service. Apart from
              healthcare, it is education that has attracted the attention of
              the SNR Sons Charitable Trust. This extraordinary penchant for
              education has resulted in bringing some of the sterling
              Educational Institutions and Courses within the reach of many, who
              would otherwise have been left dreaming about education at such
              levels.
            </p>
          </section>

          {/* About the Institution Section */}
          <section className="bg-white p-2 sm:p-6 ">
            <h2 className="text-2xl sm:text-3xl font-semibold text-center">
              About the Institution
            </h2>
            <p className="mt-4 sm:text-lg text-justify">
              Sri Ramakrishna Engineering College (SREC), Coimbatore established
              in the year 1994 by SNR Sons Charitable Trust is one of the 17
              institutions managed by the trust. SREC is an autonomous
              institution offering 12 Undergraduate programmes in the
              disciplines of Aeronautical, Biomedical, Civil, Mechanical,
              Electronics and Communication, Electrical and Electronics,
              Electronics and Instrumentation, Information Technology, Computer
              Science and Engineering, Robotics and Automation, Artificial
              Intelligence and Data Science and M.Tech Computer Science and
              Engineering (5 Year Integrated). The institution offers Seven Post
              Graduate programmes in Engineering and Technology with
              specializations of Manufacturing Engineering, Power Electronics
              and Drives, VLSI Design, Computer Science and Engineering ,
              Embedded System Technologies, Control and Instrumentation
              Engineering and Nanoscience and Technology, in addition to MBA. 
              <a href="https://srec.ac.in" style={{color:'#006298', fontWeight:600}}>Read More....</a>
            </p>
          </section>

          {/* Organizing Departments Section */}
          <section className="space-y-12">
            <h2 className="text-2xl sm:text-3xl font-semibold text-center">
              Organizing Departments
            </h2>

            {/* Departments Cards Grid */}
            <div className="flex flex-col gap-8">
              {/* Electrical and Electronics Engineering */}
              <div className="bg-white py-5 rounded-lg shadow-lg text-justify sm:p-6 p-1">
                <h3 className="text-lg sm:text-2xl font-semibold">
                  Department of Electrical and Electronics Engineering
                </h3>
                <p className="mt-8 sm:text-lg text-justify">
                  The Department of Electrical and Electronics Engineering was
                  established in 1994. It offers four year B.E. (Electrical and
                  Electronics Engineering) Programme. The department also offers
                  Ph.D. Programme to promote research activities in the areas
                  related to Electrical Engineering. The consultancy services
                  are also rendered by the department. It has a distinguished
                  team of faculty consisting of 9 Doctorates and 9 Post
                  Graduates who have registered for Ph.D. in different areas of
                  Electrical and Electronics Engineering and have rich
                  industrial/research/teaching experience. The Programmes
                  offered by the department of Electrical and Electronics
                  Engineering are Accredited by the National Board of
                  Accreditation, New Delhi.
                </p>
              </div>

              {/* Electronics and Communication Engineering */}
              <div className="bg-white py-5 rounded-lg shadow-lg text-justify sm:p-6 p-1">
                <h3 className="text-lg sm:text-2xl font-semibold">
                  Department of Electronics and Communication Engineering
                </h3>
                <p className="mt-8 sm:text-lg text-justify">
                  The Department of Electronics and Communication Engineering
                  was established in the year 1994 offering Undergraduate
                  programme in Electronics and Communication Engineering and two
                  postgraduate programmes - VLSI Design and Embedded system
                  Technologies. The UG programme is ccredited and re-accredited
                  by National Board of Accreditation, New Delhi, since 2007. The
                  department enables the students to attain excellence in domain
                  technologies of Electronics and Communication with curricula
                  focusing on the requirements specified by the industries. The
                  department has 36 faculty members with 14 members holding
                  doctoral degree, with competent expertise in the fields of
                  VLSI Design, Embedded Systems, Image and Signal Processing,
                  Communication and Networks, RF and MEMS. The department is
                  recognized as the research centre with all computing
                  facilities, State-of-Art laboratories with 29 research
                  scholars working towards potential solutions for the real-time
                  problems. The department has received grants form AICTE, New
                  Delhi, under various schemes specifically RPS, MODROBs, FDPs
                  and Seminar Grants to the tune of Rs.1 Crore. The department
                  has also received grants from DRDO, ISRO, BRNS ICMR, ISTE and
                  IEEE for seminars and workshops. The interaction of the
                  department with industries has laid path in delivering
                  consultancy projects.{" "}
                </p>
              </div>

              {/* Computer Science and Engineering */}
              <div className="bg-white py-5 rounded-lg shadow-lg sm:p-6 p-1">
                <h3 className="text-lg sm:text-2xl font-semibold">
                  Department of Computer Science and Engineering
                </h3>
                <p className="mt-8 sm:text-lg text-justify">
                  The Department of Computer Science and Engineering (CSE) was
                  established in 1994 and has since earned NBA accreditation on
                  five occasions. The department offers Post Graduate Programme
                  on M.E Artificial Intelligence and Data Science. The
                  department boasts exceptional infrastructure and has secured
                  funding from prestigious agencies such as AICTE, UGC, DRDO,
                  ISRO, and BRNS. It has also forged strategic partnerships
                  through Memoranda of Understanding (MoUs) with leading
                  organizations including TNAU, L&T Technologies, GE Healthcare,
                  Zeuron.ai, Pricol Technologies Ltd., Roots Industries India
                  Private Limited and the Health Care Centre for Innovation.
                  These collaborations focus on advancing research and
                  development in areas such as Artificial Intelligence and
                  Machine Learning (AI & ML), Augmented Reality and Virtual
                  Reality (AR & VR), Software Development, Testing, and
                  Consultancy. The department features state-of-the-art
                  laboratories, including Centres of Excellence on AR/VR, GE
                  Healthcare, Virtusa and GPU Learning Centre. It is supported
                  by a team of highly qualified faculty members dedicated to
                  fostering innovation and excellence in the field of Computer
                  Science and Engineering.{" "}
                </p>{" "}
              </div>
              <div className="bg-white py-5 rounded-lg shadow-lg sm:p-6 p-1">
                <h3 className="text-lg sm:text-2xl font-semibold">
                  Department of Information Technology
                </h3>
                <p className="mt-8 sm:text-lg text-justify">
                  The Department of Information Technology was established in
                  1998. It is accredited by National Board of Accreditation
                  (NBA) since 2007 and Permanently Affiliated to Anna
                  University, Chennai. The department has been recognized as
                  Research Center by Anna University, Chennai. The department
                  has state-of-art infrastructure facilities with experienced
                  faculty members. The department has received various funds
                  from AICTE, Anna University, NABARD, CSIR & IEEE-WIE. The
                  faculty members and students are actively involved in
                  internship and sabbaticals at Center for Brain Computing
                  Research, Bennett University, Noida. The Apple iOS Mobile
                  Application Development Laboratory was established with high
                  end iMac machines worth of INR 40 lakhs.{" "}
                </p>{" "}
              </div>
              <div className="bg-white py-5 rounded-lg shadow-lg sm:p-6 p-1">
                <h3 className="text-lg sm:text-2xl font-semibold">
                  Department of Electronics and Instrumentation Engineering
                </h3>
                <p className="mt-8 sm:text-lg text-justify">
                  The Department of Electronics and Instrumentation Engineering
                  (UG) was established in the year 2001. Also the department is
                  recognized as Research centre for pursuing PhD by Anna
                  University, Chennai. The department is accredited by National
                  Board of Accreditation (NBA), New Delhi since 2007. The
                  department is equipped with Centre of Excellence for LabVIEW
                  by National Instruments, Bangalore and Industrial Standards
                  Laboratories such as Advanced Process Control Laboratory,
                  Industrial Instrumentation Laboratory, Advanced Transducers
                  and Sensors Laboratory, Computer Control of Process Laboratory
                  etc. The department has received funds from AICTE, New Delhi
                  twice for the modernization of Computer Control of Process
                  Laboratory and Transducers & Sensors Laboratory at a cost of
                  Rs. 27, 35,420/- under MODROBs scheme. In addition, the
                  department has also involved in doing consultancy projects for
                  the industries for about Rs.45, 00,000/-. Also, the students
                  have received prizes from various project contests, and the
                  faculty members of the departments have received various
                  awards like best faculty and best mentor awards from agencies
                  like IEEE, NPTEL. The department has received grants from
                  funding agencies like AICTE, CSIR, DRDO, IEEE ISRO, ICMR,
                  ISTE, TNSCST & NI at a cost of Rs. 75,00,000/-{" "}
                </p>{" "}
              </div>
              <div className="bg-white py-5 rounded-lg shadow-lg sm:p-6 p-1">
                <h3 className="text-lg sm:text-2xl font-semibold">
                  Department of Biomedical Engineering
                </h3>
                <p className="mt-8 sm:text-lg text-justify">
                  Biomedical engineers analyze and design solutions to problems
                  in biology and medicine, with the goal of improving the
                  quality and effectiveness of patient care. Biomedical
                  engineers design instruments, devices, and software, bring
                  together knowledge from many technical sources to develop new
                  procedures or conduct research needed to solve clinical
                  problems. Biomedical engineers are employed in industry, in
                  hospitals, in research facilities of educational and medical
                  institutions, in teaching, and in government regulatory
                  agencies. They often serve a coordinating or interfacing
                  function, using their background in both engineering and
                  medical fields. In industry, they create designs where an
                  in-depth understanding of living systems and technology is
                  essential. Biomedical Engineering covers recent advances in
                  the growing field of biomedical technology, instrumentation,
                  and administration. Contributions focus on theoretical and
                  practical problems associated with the development of medical
                  technology. The introduction of new engineering methods into
                  public health, Hospitals and patient care. The improvement of
                  diagnosis and therapy. Biomedical information storage and
                  retrieval{" "}
                </p>{" "}
              </div>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
}
